import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getSurveys,
  createSurvey,
  updateSurveys,
  deleteSurvey,
  getSurveyById,
} from "api/surveys.api";

export const getSurveysAsync = createAsyncThunk("surveys/get-all", async () => {
  const data = await getSurveys();
  return data;
});

export const getNextSurveysAsync = createAsyncThunk(
  "surveys/get-all-next",
  async (last) => {
    const data = await getSurveys(last);
    return data;
  },
);

export const getSurveyByIdAsync = createAsyncThunk(
  "surveys/get-by-id",
  async (id) => {
    const survey = await getSurveyById(id);
    const response = await fetch(survey.content);
    const text = await response.text();
    return { ...survey, content: text };
  },
);

export const createSurveyAsync = createAsyncThunk(
  "surveys/create",
  async (survey) => {
    const surveys = await createSurvey(survey);
    return surveys;
  },
);

export const updateSurveyAsync = createAsyncThunk(
  "surveys/update",
  async ({ id, data }) => {
    await updateSurveys(id, data);
    return { id, ...data };
  },
);

export const deleteSurveyAsync = createAsyncThunk(
  "surveys/delete",
  async (id) => {
    await deleteSurvey(id);
  },
);
